import { ofType } from 'redux-observable';
import { debounceTime, mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_LAST_SCORING_LOGS } from '../types/getLastScoringLogsTypes';
import { SCORE_CARD_MESSAGES } from '../constants/scoreCardMessages';
import { getLastScoringLogsFulfilled, getLastScoringLogsPending, getLastScoringLogsRejected } from '../actions/runDbClientsScoringActions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import generateError from '../../../utilities/generateError';

const getLastScoringLogsPayload = payload => ({
  method: 'get',
  url: 'log/getscoringlog?take=5',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(SCORE_CARD_MESSAGES.NOT_FOUND_SCORING_LOGS)
    : getLastScoringLogsFulfilled(response))],
  onError: [
    getLastScoringLogsRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getLastScoringLogsEpic$ = action$ => action$.pipe(
  ofType(GET_LAST_SCORING_LOGS.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(getLastScoringLogsPending()),
    of(sendApiRequest(getLastScoringLogsPayload(payload), meta)),
  )),
);

export default getLastScoringLogsEpic$;


// WEBPACK FOOTER //
// ./src/features/score-card/epics/getLastScoringLogsEpic.js